import * as forgerock from '@forgerock/javascript-sdk';
import { App } from 'vue';

/// ----------------------------------------------------------------------------
// Integration with the FORGEROCK-SDK
/// ----------------------------------------------------------------------------

const APP_CONFIG = window.APP_CONFIG;

const amDomain = APP_CONFIG.forgerock.amBase;
/*const amDomain = window.location.hostname === 'localhost'
   ? APP_CONFIG.forgerock.amBase  // for local development
   : window.location.origin;*/

const amBaseURL = `${amDomain}${import.meta.env.VITE_AM_PATH}`;

/**
 * workaround to initialize the forgerock-sdk
 */
export const ForgerockPlugin = {

  install(app: App) {

    console.info('[FR] init fr-sdk...');

    /**
     * initialize the forgerock sdk
     */
    forgerock.Config.set({
      clientId: APP_CONFIG.oauth.clientId,
      redirectUri: `${window.location.origin}${import.meta.env.BASE_URL}/info/oathRegistered`,
      scope: APP_CONFIG.oauth.scopes,
      serverConfig: {
        baseUrl: amBaseURL,
        timeout: APP_CONFIG.forgerock?.timeout ?? 3000,
      },
      realmPath: import.meta.env.VITE_REALM_PATH,
      //tree: import.meta.env.VITE_REGISTER_DEVICE_TREE,
    });
  },

};

export class FrBackend {

  /**
   * TODO replace customization with this call
   * Reset OATH devices over REST
   * https://backstage.forgerock.com/docs/am/7.5/authentication-guide/authn-mfa-reset-devices.html
   */
  static resetOathDevice = (uid: string) => {
    const url = `${amBaseURL}/json/realms/root/realms${import.meta.env.VITE_REALM_PATH}/users/${uid}/devices/2fa/oath?_action=reset`;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept-API-Version': 'resource=1.0',
      },
    });
  };
}

/*
 * define a store for keeping track of the current step
 */
/*export const useFrStore = defineStore('forgerock', {
   state: () => ({
      currentStep: undefined as FRStep | undefined,
      otpAuth: '',
   }),
});*/

/*export const nextStep = (step?: FRStep) => {
   return forgerock.FRAuth.next(step)
      .then(handleStep)
      .catch(handleFatalError);
};*/

/*export const handleFatalError = (err: unknown) => {
   console.error('Fatal error', err);
};*/

// Display and bind the handler for this stage
/*export const handleStep = async (step: FRStep | FRLoginSuccess | FRLoginFailure) => {

   if (step.type === StepType.LoginSuccess || step.type === StepType.LoginFailure) {
      // return the step - it will be handled by the caller page
      return step;
   }

   const stage = step.getStage();
   // check a stage has been defined
   if (!stage) throw new Error('No stage found');
   // check there's a page matching this stage
   if (!FRPages.includes(stage)) throw new Error('Unknown stage <' + stage + '>');

   // save the current step
   useFrStore().currentStep = step;

   // go to the corresponding page
   router.push({ name: stage });

   return step; // useless - because we go to the next page
};*/

